// react
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// @mui
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
// handlers
import user from "src/components/UI/Shared/user";
// components
import BurgerMenu from "src/components/UI/Home/Main/burger-menu";
// assets
import styles from "src/layouts/assets/scss/header-simple.module.scss";
// redux
import { useSelector } from "react-redux";

interface HeaderSimpleProps {
  inHome: boolean;
  onClosePickerMode: () => void;
}
const HeaderSimple = ({ inHome, onClosePickerMode }: HeaderSimpleProps) => {
  const mobileMode = useSelector((state: any) => state.app.mobileMode);

  let navigate = useNavigate();

  const current_user = user.getCurrentLoggedIn();
  const data = localStorage.getItem(current_user);
  const _info = data !== null ? JSON.parse(data) : null;
  const currentUser = _info ? _info["session_token"] : null;
  const firstName = currentUser ? currentUser["first_name"] : null;

  useEffect(() => {
    const stack = document.querySelector(".stack_");
    if (!inHome) stack?.classList.add(styles.stackAhead);
  }, [inHome, mobileMode]);
  return (
    <>
      <Stack
        className={`${styles.stack} stack_ ${
          inHome
            ? styles.bckTrans
            : mobileMode
            ? styles.bckBlue
            : styles.bckTrans
        }`}
      >
        <div
          className={
            !mobileMode
              ? styles.logoDevBlack
              : inHome
              ? styles.logoDevBlack
              : styles.logoDevWhite
          }
          onClick={
            window.location.pathname.toLocaleLowerCase() ===
            "/Geo".toLocaleLowerCase()
              ? () => (window.location.href = "../")
              : () => navigate("../../")
          }
          style={{
            cursor: "pointer",
          }}
        />

        <div className={styles.userContainer}>
          {!mobileMode ? (
            <>
              <div className={styles.welcoming}>
                <Typography variant="h5" gutterBottom>
                  Hi,{" "}
                  {firstName !== null
                    ? firstName.charAt(0).toUpperCase() + firstName.slice(1)
                    : "Guest"}
                </Typography>
              </div>
              <div className={styles.verticalLine} />
            </>
          ) : (
            <BurgerMenu />
          )}
          <div
            className={`${
              !mobileMode
                ? styles.userIcon
                : inHome
                ? styles.userIcon
                : styles.userIconDark
            }`}
            onClick={() => {
              onClosePickerMode();
              navigate("/profile");
            }}
          />
        </div>
      </Stack>
    </>
  );
};
export default HeaderSimple;
